import styled from '@emotion/styled';
import { Modal as ModalBase } from '@ui-components/neo.tax';

export const StyledProfileEditModal = styled(ModalBase)({
  maxWidth: '400px',
  width: '100%',
});
